import { Injectable } from '@angular/core';
import { DayOfList } from '../models/list-day';

@Injectable({
  providedIn: 'root'
})
export class ListDayService {

  lastLoadingDate : Date = new Date(new Date().setHours(0,0,0,0));
  dates : DayOfList[] = new Array();

  constructor() {
    
   }
}
